module.exports = {
  context: {
    topNav: '@top-navigation',
    topUtilityNav: '@top-utility-navigation',
    primaryNav: '@primary-navigation',
    searchBar: '@search-bar',
    languageSelector: {
      nodes: '@top-utility-navigation.nodes',
      title: 'Language'
    },
    logo: {
      url: 'http://adjoin.nitro'
    },
    buttonSearch: {
      ariaLabel: 'Search'
    },
    mobileButton: {
      ariaLabel: 'Open Menu'
    },
    mobileCloseButton: {
      ariaLabel: 'Mobile Close',
      class: 'mobile-nav-close'
    }
  }
}
